import CustomQuill from './CustomQuill';

interface QuillComponentProps {
  text: string;
  updateHandler: (text: string) => void;
}

function QuillComponent({ text, updateHandler }: QuillComponentProps) {
  return (
    <>
      <CustomQuill
        defaultValue={text}
        onTextChange={updateHandler}
      />
    </>
  );
}

export default QuillComponent;
